import { keccak256 } from '@ethersproject/keccak256';
import type { BytesLike } from 'ethers';
import { MerkleTree } from 'merkletreejs';

const createTree = (leaves: string[]): MerkleTree => {
  const hashedLeaves = leaves.map(keccak256);
  const tree = new MerkleTree(hashedLeaves, keccak256, { sort: true });

  return tree;
};

export const constructTree = (leaves: string[]): BytesLike => {
  const tree = createTree(leaves);

  return tree.getHexRoot();
};

export const getProof = (leaves: string[], leaf: string): BytesLike[] => {
  const tree = createTree(leaves);
  const leafHash = keccak256(leaf);

  return tree.getHexProof(leafHash);
};

export const verify = (leaves: string[], leaf: string): boolean => {
  const tree = createTree(leaves);

  const root = tree.getHexRoot();
  const leafHash = keccak256(leaf);
  const proof = tree.getHexProof(leafHash);

  return tree.verify(proof, leafHash, root);
};
